export const commonTypes = {
  SET_INIT_FLOW: 'COMMON/SET_INIT_FLOW',
  SET_SELECT_ELEMENTS_NEEDS: 'COMMON/SET_SELECT_ELEMENTS_NEEDS',
  SET_CLIENT_INFO: 'COMMON/SET_CLIENT_INFO',
  SET_UPDATE_MY_CONTACTS_SUCCESS: 'COMMON/SET_UPDATE_MY_CONTACTS_SUCCESS',
  SET_PERMANENT_RESIDENCE_INFO: 'COMMON/SET_PERMANENT_RESIDENCE_INFO',
  SET_PERMANENT_RESIDENCE_ADDRESS_NAME: 'COMMON/SET_PERMANENT_RESIDENCE_ADDRESS_NAME',
  SET_UPDATE_PERMANENT_RESIDENCE_SUCCESS: 'COMMON/SET_UPDATE_PERMANENT_RESIDENCE_SUCCESS',
  SET_ADD_TO_CART_NEEDS: 'COMMON/SET_ADD_TO_CART_NEEDS',
  INITIALIZE_RESET_FLOW: 'COMMON/INITIALIZE_RESET_FLOW',
  GO_TO_PERSONAL_DATA_STEP: 'COMMON/GO_TO_PERSONAL_DATA_STEP',
  RESET_FLOW: 'COMMON/RESET_FLOW',
  SET_MAIN_ACTION_INFO: 'COMMON/SET_MAIN_ACTION_INFO',
  SET_MAIN_ACTION_ADDITIONAL_INFO: 'COMMON/SET_MAIN_ACTION_ADDITIONAL_INFO',
  SET_SECONDARY_ACTION_INFO: 'COMMON/SET_SECONDARY_ACTION_INFO',
  SET_SECONDARY_ACTION_ADDITIONAL_INFO: 'COMMON/SET_SECONDARY_ACTION_ADDITIONAL_INFO',
  SET_SE_INFO: 'COMMON/SET_SE_INFO',
  SET_GENESYS_OK: 'COMMON/SET_GENESYS_OK',
  SET_PARENT_PRODUCTS_TO_SELECT: 'COMMON/SET_PARENT_PRODUCTS_TO_SELECT',
  SET_PARENT_PRODUCT_SELECTED: 'COMMON/SET_PARENT_PRODUCT_SELECTED',
  SET_CONFIRMED_STEP: 'COMMON/SET_CONFIRMED_STEP',
  SET_INSTALLATION_ADDRESS: 'COMMON/SET_INSTALLATION_ADDRESS',
  SET_INSTALLATION_ADDRESS_NAME: 'COMMON/SET_INSTALLATION_ADDRESS_NAME',
  SET_NEW_INSTALLATION_ADDRESS_WANTED: 'COMMON/SET_NEW_INSTALLATION_ADDRESS_WANTED',
  SET_PPIP_AS_AVAILABLE: 'COMMON/SET_PPIP_AS_AVAILABLE',
  SET_BLOCKED_BY_OBD_STATUS: 'COMMON/SET_BLOCKED_BY_OBD_STATUS',
  SET_OBD_LINES: 'COMMON/SET_OBD_LINES',
  SET_MY_PRODUCTS_INFO: 'COMMON/SET_MY_PRODUCTS_INFO',
  SET_NON_FIBER_COVERAGE: 'COMMON/SET_NON_FIBER_COVERAGE',
  SET_LEGAL_TERMS_INFO: 'COMMON/SET_LEGAL_TERMS_INFO',
  SET_SELECTED_FUNDING_OFFER: 'COMMON/SET_SELECTED_FUNDING_OFFER',
  SET_TERMINAL_INFO: 'COMMON/SET_TERMINAL_INFO',
  MOBILE_INSURANCE: 'COMMON/MOBILE_INSURANCE',
  SET_POPT_SELECTED: 'COMMON/SET_POPT_SELECTED',
  SET_OFFER_INFO: 'COMMON/SET_OFFER_INFO',
  RESET_ASCERTAIN: 'COMMON/RESET_ASCERTAIN',
  SET_PRODUCT_OFFERING_INFO: 'COMMON/SET_PRODUCT_OFFERING_INFO',
  SET_ALL_PROMOS_ID: 'COMMON/SET_ALL_PROMOS_ID',
  SET_ALREADY_OWNED_PRODUCTS_CHOICES: 'COMMON/SET_ALREADY_OWNED_PRODUCTS_CHOICES',
  SET_ALREADY_OWNED_PRODUCT_CHOICE_SELECTED: 'COMMON/SET_ALREADY_OWNED_PRODUCT_CHOICE_SELECTED',
  SET_PRICES_CHANGE_INFO: 'COMMON/SET_PRICES_CHANGE_INFO',
  SET_PPIP_SELECTED: 'COMMON/SET_PPIP_SELECTED',
  SET_PERSONAL_CONTACT_INFO: 'COMMON/SET_PERSONAL_CONTACT_INFO',
  SET_ADDRESS_INFO: 'COMMON/SET_ADDRESS_INFO',
  SET_SHIPPING_ADDRESS_NAME: 'COMMON/SET_SHIPPING_ADDRESS_NAME',
  SET_ACCOUNT_INFO: 'COMMON/SET_ACCOUNT_INFO',
  SET_VTL_DATA_FOR_CONFIRMATION: 'COMMON/SET_VTL_DATA_FOR_CONFIRMATION',
  SET_AFTER_SALE_PARENT_PRODUCT: 'COMMON/SET_AFTER_SALE_PARENT_PRODUCT',
  SET_POIT_SELECTED: 'COMMON/SET_POIT_SELECTED',
  SET_POSHT_SELECTED: 'COMMON/SET_POSHT_SELECTED',
  SET_REGISTER_INPUT_VALUE: "COMMON.SET_REGISTER_INPUT_VALUE",
  REGISTER_SHOPPER: "COMMON.REGISTER_SHOPPER",
  VALIDATE_SHOPPER: "COMMON.VALIDATE_SHOPPER",
  SET_PORTABILITY_OTP_NEEDED: "COMMON.SET_PORTABILITY_OTP_NEEDED",
  SET_R2R_TO_CANCEL_INFO: 'COMMON/SET_R2R_TO_CANCEL_INFO',
};

export const commonActions = {
  setInitFlow: () => ({
    type: commonTypes.SET_INIT_FLOW,
  }),
  setClientInfo: clientInfo => ({
    type: commonTypes.SET_CLIENT_INFO,
    payload: {
      ...clientInfo,
    },
  }),
  setSelectElementsNeeds: info => ({
    type: commonTypes.SET_SELECT_ELEMENTS_NEEDS,
    payload: {
      ...info,
    },
  }),
  setUpdateMyContactsSuccess: info => ({
    type: commonTypes.SET_UPDATE_MY_CONTACTS_SUCCESS,
    payload: {
      ...info,
    },
  }),
  setUpdatePermanentResidenceNeeds: addressInfo => ({
    type: commonTypes.SET_PERMANENT_RESIDENCE_INFO,
    payload: {
      ...addressInfo,
    },
  }),
  setPermanentResidenceAddressName: address => ({
    type: commonTypes.SET_PERMANENT_RESIDENCE_ADDRESS_NAME,
    payload: {
      address,
    },
  }),
  setUpdatePermanentResidenceSuccess: info => ({
    type: commonTypes.SET_UPDATE_PERMANENT_RESIDENCE_SUCCESS,
    payload: {
      ...info,
    },
  }),
  setAddToCartNeeds: info => ({
    type: commonTypes.SET_ADD_TO_CART_NEEDS,
    payload: {
      ...info,
    },
  }),
  resetFlow: () => ({
    type: commonTypes.RESET_FLOW,
  }),
  initializeResetFlow: isPersonalDataStep => ({
    type: commonTypes.INITIALIZE_RESET_FLOW,
    payload: {
      isPersonalDataStep,
    },
  }),
  goToPersonalDataStep: () => ({
    type: commonTypes.GO_TO_PERSONAL_DATA_STEP,
  }),
  setMainActionInfo: actionInfo => ({
    type: commonTypes.SET_MAIN_ACTION_INFO,
    payload: {
      ...actionInfo,
    },
  }),
  setMainActionAdditionalInfo: mainActionObj => ({
    type: commonTypes.SET_MAIN_ACTION_ADDITIONAL_INFO,
    payload: {
      ...mainActionObj,
    },
  }),
  setSecondaryActionInfo: actionObj => ({
    type: commonTypes.SET_SECONDARY_ACTION_INFO,
    payload: {
      ...actionObj,
    },
  }),
  setSecondaryActionAdditionalInfo: secondaryActionObj => ({
    type: commonTypes.SET_SECONDARY_ACTION_ADDITIONAL_INFO,
    payload: {
      ...secondaryActionObj,
    },
  }),
  setSEInfo: info => ({
    type: commonTypes.SET_SE_INFO,
    payload: {
      ...info,
    },
  }),
  setGenesysOk: () => ({
    type: commonTypes.SET_GENESYS_OK,
  }),
  setParentProductsToSelect: parentProducts => ({
    type: commonTypes.SET_PARENT_PRODUCTS_TO_SELECT,
    payload: {
      parentProducts,
    },
  }),
  setParentProductSelected: productSelected => ({
    type: commonTypes.SET_PARENT_PRODUCT_SELECTED,
    payload: {
      productSelected,
    },
  }),
  setConfirmedStep: confirmedStep => ({
    type: commonTypes.SET_CONFIRMED_STEP,
    payload: {
      confirmedStep,
    },
  }),
  setInstallationAddress: installationAddress => ({
    type: commonTypes.SET_INSTALLATION_ADDRESS,
    payload: {
      installationAddress,
    },
  }),
  setInstallationAddressName: address => ({
    type: commonTypes.SET_INSTALLATION_ADDRESS_NAME,
    payload: {
      address,
    },
  }),
  setPpipAsAvailable: info => ({
    type: commonTypes.SET_PPIP_AS_AVAILABLE,
    payload: { ...info },
  }),
  setBlockedByObdStatus: status => ({
    type: commonTypes.SET_BLOCKED_BY_OBD_STATUS,
    payload: {
      status,
    },
  }),
  setObdLines: lines => ({
    type: commonTypes.SET_OBD_LINES,
    payload: {
      lines,
    },
  }),
  setMyProductsInfo: info => ({
    type: commonTypes.SET_MY_PRODUCTS_INFO,
    payload: {
      ...info,
    },
  }),
  setNonFiberCoverage: nonFiberCoverage => ({
    type: commonTypes.SET_NON_FIBER_COVERAGE,
    payload: {
      nonFiberCoverage,
    },
  }),
  setLegalTermsInfo: info => ({
    type: commonTypes.SET_LEGAL_TERMS_INFO,
    payload: {
      ...info,
    },
  }),
  setSelectedFundingOffer: selectedFundingOffer => ({
    type: commonTypes.SET_SELECTED_FUNDING_OFFER,
    payload: {
      selectedFundingOffer,
    },
  }),
  setTerminalInfo: info => ({
    type: commonTypes.SET_TERMINAL_INFO,
    payload: {
      ...info,
    },
  }),
  setMobileInsurance: insurance => ({
    type: commonTypes.MOBILE_INSURANCE,
    payload: { insurance },
  }),
  setPoptSelected: poptSelected => ({
    type: commonTypes.SET_POPT_SELECTED,
    payload: {
      poptSelected,
    },
  }),
  setOfferInfo: offerInfo => ({
    type: commonTypes.SET_OFFER_INFO,
    payload: {
      ...offerInfo,
    },
  }),
  resetAscertain: () => ({
    type: commonTypes.RESET_ASCERTAIN,
  }),
  setProductOfferingInfo: info => ({
    type: commonTypes.SET_PRODUCT_OFFERING_INFO,
    payload: {
      ...info,
    },
  }),
  setAllPromosId: allPromos => ({
    type: commonTypes.SET_ALL_PROMOS_ID,
    payload: {
      allPromos,
    },
  }),
  setAlreadyOwnedProductsChoices: alreadyOwnedProductsChoicesObj => ({
    type: commonTypes.SET_ALREADY_OWNED_PRODUCTS_CHOICES,
    payload: {
      alreadyOwnedProductsChoicesObj,
    },
  }),
  setAlreadyOwnedProductChoiceSelected: alreadyOwnedProductChoiceSelected => ({
    type: commonTypes.SET_ALREADY_OWNED_PRODUCT_CHOICE_SELECTED,
    payload: {
      ...alreadyOwnedProductChoiceSelected,
    },
  }),
  setPricesChangesInfo: info => ({
    type: commonTypes.SET_PRICES_CHANGE_INFO,
    payload: {
      ...info,
    },
  }),
  setPpipSelected: ppipSelected => ({
    type: commonTypes.SET_PPIP_SELECTED,
    payload: {
      ppipSelected,
    },
  }),
  setPersonalContactInfo: personalContactInfo => ({
    type: commonTypes.SET_PERSONAL_CONTACT_INFO,
    payload: {
      ...personalContactInfo,
    },
  }),
  setAddressInfo: addressInfo => ({
    type: commonTypes.SET_ADDRESS_INFO,
    payload: {
      ...addressInfo,
    },
  }),
  setShippingAddressName: address => ({
    type: commonTypes.SET_SHIPPING_ADDRESS_NAME,
    payload: {
      address,
    },
  }),
  setAccountInfo: accountInfo => ({
    type: commonTypes.SET_ACCOUNT_INFO,
    payload: {
      ...accountInfo,
    },
  }),
  setAfterSaleParentProduct: afterSaleParentProduct => ({
    type: commonTypes.SET_AFTER_SALE_PARENT_PRODUCT,
    payload: {
      afterSaleParentProduct,
    }
  }),
  setPoitSelected: poitSelected => ({
    type: commonTypes.SET_POIT_SELECTED,
    payload: {
      poitSelected,
    },
  }),
  setPoshtSelected: poshtSelected => ({
    type: commonTypes.SET_POSHT_SELECTED,
    payload: {
      poshtSelected,
    },
  }),
  setRegisterInputValue: (data) => ({
    type: commonTypes.SET_REGISTER_INPUT_VALUE,
    payload: data,
  }),
  registerShopper: (data) => ({
    type: commonTypes.REGISTER_SHOPPER,
    data,
  }),
  validateShopper: (pin) => ({
    type: commonTypes.VALIDATE_SHOPPER,
    pin,
  }),
  setPortabilityOTPNeeded: (otpNeeded) => ({
    type: commonTypes.SET_PORTABILITY_OTP_NEEDED,
    payload: {
      otpNeeded,
    },
  }),
  setR2RToCancelInfo: r2rToCancelInfo => ({
    type: commonTypes.SET_R2R_TO_CANCEL_INFO,
    payload: {
      newR2RToCancelInfo: r2rToCancelInfo,
    },
  }),
};
